<template>
  <cookie-law
    theme="dark-lime"
    class="cookie-bar"
    button-text="Accept"
    button-class="vs-button vs-button-primary vs-button-filled"
    ><div slot="message">
      This Website uses Cookies to improve the usability. By using this Website you declare your
      consent for Cookies to be used as well as with the privacy policy where you can find more
      information on Cookies. Link:
      <router-link :to="{ name: 'compliance_privacypolicy' }" target="_blank"
        >Privacy policy</router-link
      >.
    </div></cookie-law
  >
</template>

<script>
import CookieLaw from "vue-cookie-law";

export default {
  name: "Cookies",
  components: { CookieLaw },
};
</script>
